import React from "react";
import Navbar from "./Navbar";
import Footer from "./Footer";
import FloatingWindow from "../FloatingWindow";
import useHealthStatus from "../../hooks/useHealthStatus";
import { useStore } from "../../store/useStore";
import { Box, CircularProgress, Typography, Button } from "@mui/material";

export const Layout = ({ children }) => {
  const { data: health, error, loading, refetch } = useHealthStatus();

  const timerVisible = useStore((state) => state.timerVisible);

  const isDataReady = !!health || !!error;

  const isFail = isDataReady && (error || health?.status === "degraded" || health?.status === "fail" || !health?.backend);

  const isStaging = process.env.REACT_APP_NODE_ENV === "staging";

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        minHeight: "100vh",

        "@supports (min-height: 100dvh)": {
          minHeight: "100dvh",
        },
      }}
    >
      <Navbar health={health} loading={loading} error={error} />

      {/* Staging env notification */}
      {isStaging && (
        <Box
          sx={{
            backgroundColor: "#ef4444",
            color: "#ffffff",
            py: 0.5,
            px: 1,
            textAlign: "center",
            mt: 8,

            fontSize: {
              xs: "12px",
              sm: "14px",
              md: "16px",
            },
          }}
        >
          Esta es la página de pruebas
        </Box>
      )}

      <FloatingWindow />

      <Box
        component="main"
        sx={{
          flexGrow: 1,
          width: "100%",
          minHeight: 0,
          boxSizing: "border-box",
          pt: timerVisible
            ? {
                xs: 17,
                sm: 17,
                lg: 10,
              }
            : 10,

          px: {
            xs: 1.5,
            sm: 2,
            md: 3,
          },

          pb: {
            xs: 2,
            sm: 3,
          },
        }}
      >
        {!isDataReady ? (
          <Box
            sx={{
              minHeight: {
                xs: "60dvh",
                sm: "70vh",
              },
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <CircularProgress />
          </Box>
        ) : isFail ? (
          <Box
            sx={{
              minHeight: {
                xs: "60dvh",
                sm: "70vh",
              },
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              alignItems: "center",
              textAlign: "center",
              px: 2,
            }}
          >
            <Typography
              variant="h4"
              gutterBottom
              color="error"
              sx={{
                fontSize: {
                  xs: "1.5rem",
                  sm: "2rem",
                  md: "2.125rem",
                },
              }}
            >
              El sistema no está disponible
            </Typography>

            <Typography
              variant="body1"
              sx={{
                maxWidth: 400,
                mb: 2,
                fontSize: {
                  xs: "0.875rem",
                  sm: "1rem",
                },
              }}
            >
              Estamos presentando inconvenientes técnicos. Por favor, intente nuevamente en unos minutos.
            </Typography>

            <Button
              variant="contained"
              onClick={refetch}
              sx={{
                width: {
                  xs: "100%",
                  sm: "auto",
                },
                maxWidth: {
                  xs: 320,
                  sm: "none",
                },
              }}
            >
              Reintentar ahora
            </Button>
          </Box>
        ) : (
          children
        )}
      </Box>

      <Footer />
    </Box>
  );
};
